import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { GrCheckmark } from "react-icons/gr";
import { Check } from "heroicons-react";

export default function Checkbox(props) {
  const { id, label, asHtml, required } = props;

  const { register, unregister, setValue, value, alwaysTrue } = props;
  const [internalValue, setInternalValue] = useState(alwaysTrue ? true : Boolean(value));

  useEffect(() => {
    register(id, internalValue);
    return () => unregister(id);
  }, [register, unregister, id, internalValue]);

  const onChange = (event) => {
    if (alwaysTrue) return;
    const newValue = event.target.checked;
    setInternalValue(newValue);
    setValue(id, newValue);
  };

  return (
    <label className={classNames("flex justify-start items-start", props.className)}>
      <div
        className={classNames(
          "border-2 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-400 border-gray-400",
          {}
        )}
      >
        <input
          type="checkbox"
          className="absolute opacity-0"
          onChange={onChange}
          checked={internalValue}
          required={required}
        />
        {internalValue && <Check className="font-bold" />}
      </div>
      {!asHtml && label && <div className="select-none">{label}</div>}
      {asHtml && label && <div className="select-none" dangerouslySetInnerHTML={{ __html: label }}></div>}
    </label>
  );
}
